import { render, staticRenderFns } from "./EmpresaGroup.vue?vue&type=template&id=c4eb16de"
import script from "./EmpresaGroup.vue?vue&type=script&lang=js"
export * from "./EmpresaGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports